export const CHAT_STRINGS = {
  title: 'Chat',
  client: 'Client',
  halLeonard: 'Hal Leonard',
  closed: 'Chat closed',
  close: 'Close chat',
  expand: 'Expand chat',
  collapse: 'Collapse chat',
} as const
